


















import { Prop, Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import Delivery from '@/dto/deliveries/Delivery'
import StaticFields from '@/components/delivery/preferences/StaticFields.vue'
import DynamicFields from '@/components/delivery/preferences/DynamicFields.vue'
import BoxForm from '@/components/delivery/preferences/BoxForm.vue'
import Field from '@/dto/deliveries/Field'
import deliveryService from '@/services/DeliveryService'
import PreferencesFooter from '@/components/delivery/preferences/PreferencesFooter.vue'
import { Errors } from '@/dto/ErrorsResponse'
import deliveryStore from '@/stores/DeliveryStore'

@Component({
  components: { PreferencesFooter, BoxForm, DynamicFields, StaticFields },
})
export default class Preferences extends Vue {
  @Prop(Object)
  model: Delivery
  deliveryStore = deliveryStore
  dynamicFields: Field[] = []
  dynamicFieldsPending: boolean = false

  get errors(): Errors {
    return this.deliveryStore.validationErrors
  }

  setErrors(errors: Errors) {
    this.deliveryStore.setErrors(errors)
  }

  @Watch('model.calculatorType', { immediate: true })
  async addFields() {
    if (!this.model.calculatorType) {
      this.dynamicFields = []
      return
    }

    this.dynamicFieldsPending = true

    const fields: Field[] = await deliveryService.getFields({
      deliveryType: this.model.type,
      calculatorType: this.model.calculatorType,
      deliveryId: this.model.id,
    })

    this.dynamicFieldsPending = false
    this.dynamicFields = fields
  }

  @Watch('model')
  resetErrors() {
    if (this.deliveryStore.hasErrors) {
      this.deliveryStore.setErrors({})
    }
  }
}
